export const environment = {
  production: true,
  appConfig: 'appconfig.' + window['env']['ASPNETCORE_ENVIRONMENT'] + '.json',
};
